import { withResult } from 'feathers-fletching';
import { statusType, truckType } from 'straightline-utils/constants';

const withResults = withResult({
  status: (shipment) => {
    if (shipment.status_type) {
      return statusType(shipment.status_type);
    }
  },
  truck: (shipment) => {
    if (shipment.truck_type) {
      return truckType(shipment.truck_type);
    }
  },
  pickup_address: async (match, context) => {
    if (!match.pickup_address) {
      return match.pickup_address;
    }

    if (!context.params.$include?.includes('pickup_address')) {
      return match.pickup_address;
    }

    try {
      const { latitude, longitude, position } = await context.app
        .service('google/geocode')
        .find({
          query: {
            address: `${match.pickup_address.city || ''}, ${
              match.pickup_address.state || ''
            } ${match.pickup_address.country || ''}`
          }
        });

      return {
        ...match.pickup_address,
        latitude,
        longitude,
        position
      };
    } catch (error) {
      return match.delivery_address;
    }
  },
  delivery_address: async (match, context) => {
    if (!match.delivery_address) {
      return match.delivery_address;
    }

    if (!context.params.$include?.includes('delivery_address')) {
      return match.delivery_address;
    }

    try {
      const { latitude, longitude, position } = await context.app
        .service('google/geocode')
        .find({
          query: {
            address: `${match.delivery_address.city || ''}, ${
              match.delivery_address.state || ''
            } ${match.delivery_address.country || ''}`
          }
        });

      return {
        ...match.delivery_address,
        latitude,
        longitude,
        position
      };
    } catch (error) {
      return match.delivery_address;
    }
  },
  shipment_requests: async (result, context) => {
    if (!context.params.$include?.includes('shipment_requests')) {
      return undefined;
    }

    const { total } = await context.app.service('api/shipment-requests').find({
      query: {
        $limit: 0,
        shipment_id: result.id
      }
    });

    return total;
  },
  shipment_offers: async (result, context) => {
    if (!context.params.$include?.includes('shipment_offers')) {
      return undefined;
    }

    const offers = await context.params.loader
      .service('api/shipment-offers')
      .multi('shipment_id')
      .load(result.id, {
        query: {
          user_id: context.app.auth.user.id
        }
      });

    if (!offers) {
      return null;
    }

    return [...offers].sort((a, b) => {
      return new Date(a.created_at) - new Date(b.created_at);
    });
  }
});

export default {
  before: {
    all: [],
    find: [],
    update: []
  },
  after: {
    all: [],
    find: [withResults],
    get: [withResults],
    update: [withResults]
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
